import React, { useState, useEffect, memo } from "react";
import { KendoMultiSelect } from "../../../Kendo/kendo_multiselect";
import { useDispatch, useSelector } from "react-redux";
import {
  getGeneralReviewBarData,
  getReviewBarData,
  getReviewCardData,
  getReviewData,
} from "../CustomerStatisfation/CustomerStatisficationSlice";
import { changeType, getRevenuData } from "./RevenueSlice";
import { GetExecutionData } from "../Execution/Executionslice";
import { GetSalesData } from "../Sales/SalesSlice";

const RevenueMatrix = ({
  calendarValue,
  matrixValue,
  selectedYear,
  filter,
  data,
  csStatisfaction,
  sales,
  revenue,
  Execution
}) => {
  const { selectedMonth, refresh, type, year, metrics } = useSelector(
    (state) => state.revenue
  );
  const dispatch = useDispatch();
  const [flag, setFlag] = useState(false);
  const [Value, setValue] = useState([]);

  const handleChange = (e) => {
    let numString = e;
    let numArray = numString.split(",");
    if (numArray[0] == "0" || !numArray.includes("0")) {
      numArray =
        numArray.length > 1 ? numArray.filter((num) => num !== "0") : numArray;
    } else {
      numArray =
        numArray.length > 1 ? numArray.filter((num) => num == "0") : numArray;
    }
    setValue(numArray);
    if (numArray.length > 1) {
      setFlag(true);
    } else {
      setFlag(false);
    }
  };

  useEffect(() => {
    if (Value.length > 0)
      if(csStatisfaction){
        dispatch(
          getReviewData({
            type: calendarValue,
            years: selectedYear,
            filter: filter,
            metrics: matrixValue,
            value: Value.join(","),
          })
        );
      } else if(sales){
        dispatch(
          GetSalesData({
            type: calendarValue,
            years: selectedYear,
            filter: filter,
            metrics: matrixValue,
            value: Value.join(","),
          })
        );
      } else if(revenue){
        dispatch(
          getRevenuData({
            type: calendarValue,
            years: selectedYear,
            filter: filter,
            metrics: matrixValue,
            value: Value.join(","),
          })
        );
      } else if(Execution){
        dispatch(
          GetExecutionData({
            type: calendarValue,
            years: selectedYear,
            filter: filter,
            metrics: matrixValue,
            value: Value.join(","),
          })
        );
      }

    dispatch(
      changeType({
        type:calendarValue,
        filter: filter,
        metrices: matrixValue,
        metricesValue: Value,
      })
    );
  }, [Value]);

  return (
    <>
      <KendoMultiSelect
        name="revenueMatrix"
        data={data != undefined ? data : []}
        dataTextField={"Value"}
        dataValueField={"Value"}
        value={Value}
        onChange={handleChange}
        tagmode={flag ? "single" : "multiple"}
        refreshWhen={flag}
      />
    </>
  );
};
export default memo(RevenueMatrix);
